module.exports = __webpack_public_path__ + "static/media/012.a61d8ab6.jpg";